// Shared bits for the "Stop" control shown on every thinking surface
// (input overlay / refine scanning row / synthetic loader bubble /
// pending-turn bubble). The button markup stays in each component's
// template (each shadow root owns its styles), but the icon + the
// composed-event dispatch are shared so all surfaces stay in sync with
// root <emma-chat>'s handleStopThinking (QA #3).

import { html } from 'lit';

/** Event name root <emma-chat> listens for. Bubbles + composed so it
 *  crosses the nested shadow roots exactly like emma-clear-conversation. */
export const STOP_THINKING_EVENT = 'emma-stop-thinking';

/** Small square "stop" glyph — sized to sit next to var(--text-sm) labels. */
export function stopIcon() {
  return html`
    <svg width="10" height="10" viewBox="0 0 10 10" fill="none" aria-hidden="true">
      <rect x="1" y="1" width="8" height="8" rx="2" fill="currentColor" />
    </svg>
  `;
}

/** Dispatch the composed stop event from any thinking surface. */
export function dispatchStopThinking(target: EventTarget): void {
  target.dispatchEvent(
    new CustomEvent(STOP_THINKING_EVENT, { bubbles: true, composed: true }),
  );
}
